const navItems = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Products', href: '#products' },
  { label: 'Features', href: '#features' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <span className="text-stone-900 font-semibold text-lg">TUL d.o.o.</span>
            <p className="mt-3 text-stone-500 text-sm leading-relaxed max-w-xs">
              A team of experts developing modern applications for the iOS platform, focused on security and user experience.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-stone-400 mb-4">Navigation</h4>
            <ul className="flex flex-col gap-2.5">
              {navItems.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => handleNav(item.href)}
                    className="text-sm text-stone-600 hover:text-stone-900 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-stone-400 mb-4">Contact Info</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-stone-600">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 shrink-0" />
                <span>Loka 16, Logatec, 1370, Slovenia</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line shrink-0" />
                <span>contact@tuldoo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line shrink-0" />
                <span>+1 6626768248</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-400">&copy; {new Date().getFullYear()} TUL d.o.o. All rights reserved.</p>
          <p className="text-xs text-stone-400">Logatec, Slovenia</p>
        </div>
      </div>
    </footer>
  );
}
